"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.computeBorder = void 0;

var computeBorder = function computeBorder(edieProps) {
  if (edieProps['borderSize'] && edieProps['borderColor']) {
    return {
      key: 'border',
      value: edieProps['borderSize'] + ' solid ' + edieProps['borderColor']
    };
  }

  return null;
};

exports.computeBorder = computeBorder;